/*
 * Basket: show the picture of each charm-builder design on its base line (keychain/bracelet),
 * and list that line first so the design reads top to bottom. The picture is saved by
 * charm-builder.js in this browser when the design is added to the basket.
 */
(function () {
  if (window.charmBuilderCart) return;
  window.charmBuilderCart = true;

  const style = document.createElement('style');
  style.textContent = `
    .mb-cart-preview { margin: 1.2rem 0 0; max-width: 32rem; }
    .mb-cart-preview img { display: block; width: 100%; height: auto; border-radius: 0.8rem; border: 1px solid rgba(var(--color-foreground), 0.12); background: #fff; }
    .mb-cart-preview figcaption { font-size: 1.2rem; margin-top: 0.4rem; color: rgba(var(--color-foreground), 0.7); }
    cart-drawer .mb-cart-preview { max-width: 100%; }
  `;
  document.head.appendChild(style);

  function saved() {
    try {
      return JSON.parse(localStorage.getItem('mb-designs') || '[]');
    } catch (e) {
      return [];
    }
  }

  let queued = false;
  function apply() {
    queued = false;
    const designs = saved();
    document.querySelectorAll('tr[data-design-base]').forEach((row) => {
      const code = row.dataset.design;
      const first = row.parentElement.querySelector(`tr[data-design="${CSS.escape(code)}"]`);
      if (first && first !== row) row.parentElement.insertBefore(row, first);

      const design = designs.find((d) => d.code === code);
      const src = design ? design.src : row.dataset.designPicture;
      if (!src || row.querySelector('.mb-cart-preview')) return;
      const figure = document.createElement('figure');
      figure.className = 'mb-cart-preview';
      const img = document.createElement('img');
      img.src = src;
      img.alt = `Your design ${code}`;
      const caption = document.createElement('figcaption');
      caption.textContent = 'Your design';
      figure.append(img, caption);
      row.querySelector('.cart-item__details').appendChild(figure);
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(apply);
  }

  // Dawn re-renders the basket after every quantity change, so re-apply whenever it does.
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  queue();
})();
